import { svaraApi } from '../utils/axiosInstance';

/**
 * The player block list (trinity-nest gateway-game `/api/player/blocks/:targetPlayerId`). A block
 * works both ways: neither player can message the other or send them a donation. The API only
 * ever says whether the caller blocked the other player, never whether they were blocked back.
 * Blocking twice or unblocking a player who is not blocked is not an error.
 */
export interface BlockStatus {
	blockedByMe: boolean;
}

const blockPath = (playerId: string) => `/api/player/blocks/${encodeURIComponent(playerId)}`;

/** A player the caller blocked, as `GET /api/player/blocks` lists them. */
export interface BlockedPlayer {
	id: string;
	username: string | null;
	avatarFileId: string | null;
	isVip: boolean;
}

/** The caller's own block list, alphabetical. Never who blocked the caller. */
export async function listBlockedPlayers(): Promise<BlockedPlayer[]> {
	const response = await svaraApi.get<{ items: BlockedPlayer[] }>('/api/player/blocks');
	return response.data?.items ?? [];
}

export async function getBlockStatus(playerId: string): Promise<BlockStatus> {
	const response = await svaraApi.get<BlockStatus>(blockPath(playerId));
	return response.data;
}

export async function blockPlayer(playerId: string): Promise<BlockStatus> {
	const response = await svaraApi.post<BlockStatus>(blockPath(playerId));
	return response.data;
}

export async function unblockPlayer(playerId: string): Promise<BlockStatus> {
	const response = await svaraApi.delete<BlockStatus>(blockPath(playerId));
	return response.data;
}
